import { render, staticRenderFns } from "./section-card-headlines.vue?vue&type=template&id=2c76b331&scoped=true&"
import script from "./section-card-headlines.vue?vue&type=script&lang=js&"
export * from "./section-card-headlines.vue?vue&type=script&lang=js&"
import style0 from "./section-card-headlines.vue?vue&type=style&index=0&id=2c76b331&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2c76b331",
  null
  
)

export default component.exports